import { Col } from 'antd';
import WithSlideInComponent from 'components/WithSlideInComponent';
import breakpoints from 'constants/breakpoints';
import styled from 'styled-components';

export const StatusTextStyled = styled.span<{ color?: string }>`
  color: ${({ color }) => color || 'black'};
`;

export const FilterBarContainerStyled = styled.div`
  height: 100%;
`;

export const TableContainerStyled = styled(Col)`
  width: 100%;
  height: 100%;
  overflow: auto;
  padding: 15px;
  & .ant-table-pagination.ant-pagination {
    margin-right: 10px;
  }
`;

export const WithSlideInComponentStyled = styled(WithSlideInComponent)`
  & .slide-in {
    width: 65%;
    min-width: 65%;
    @media screen and (max-width: ${breakpoints.lg}) {
      min-width: 600px;
      width: 600px;
    }
  }
`;
